/*
 * Copyright (C) 2018 BarD Software s.r.o
 *
 * Author: Dmitry Barashev (dbarashev@bardsoftware.com)
 */
// import * as firebase from 'firebase/app';
// import 'firebase/analytics';
// import {initFirebase} from "../auth/FirebaseAuth";

const hostname = window.location.hostname;
const isProd = hostname.endsWith("ganttproject.cloud");

declare const ga: any;

function whenEnabled(code: () => void) {
    if (!isProd) {
        return;
    }
    const cookie = document.cookie;
    if (cookie) {
        cookie.split(';').forEach(function(keyValue) {
            if (keyValue.trim() === 'ga_opt_out=true') {
                window['ga-disable-UA-1173427-8'] = true;
            }
            return;
        });
    }
    code();
}

export function installGoogleAnalytics() {
    whenEnabled(() => {
            /* tslint:disable */
            // @ts-ignore
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            // @ts-ignore
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            // @ts-ignore
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

            // @ts-ignore
            ga('create', 'UA-1173427-8', 'auto');
            // @ts-ignore
            ga('send', 'pageview');
        }
    );
}

export function sendSignup() {
    sendEvent('Auth', 'signup');
}

export function sendEvent(category: string, action: string) {
    whenEnabled(() => {
        ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action
        });
    })

}